// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"31b95e19","455":"00b6fb8f"}[chunkId] + ".chunk.js";
};